import React, { useEffect, useState } from "react";
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';

import { Link, useNavigate, useParams } from "react-router-dom";
import CompanyDetails from "./CustomerProfileEdit/CompanyDetails";
import BankDetails from "./CustomerProfileEdit/BankDetails";
import Documentation from "./CustomerProfileEdit/Documentation";
import Declaration from "./CustomerProfileEdit/Declaration";
import { getCustomerProfileData } from "../../Redux/action/Admin/CustomerAction";
import { useDispatch, useSelector } from "react-redux";

const CustomerProfile = ({ loadingCustomerProfileDataApi, CustomerProfileDataError, CustomerProfileData, disbaledProfileEditing }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();



    return (
        <div className="page-wrapper">
            <div className="content">

                <CompanyDetails loadingCustomerProfileDataApi={loadingCustomerProfileDataApi} CustomerProfileDataError={CustomerProfileDataError} CustomerProfileData={CustomerProfileData} disbaledProfileEditing={disbaledProfileEditing}/>
                <BankDetails loadingCustomerProfileDataApi={loadingCustomerProfileDataApi} CustomerProfileDataError={CustomerProfileDataError} CustomerProfileData={CustomerProfileData} disbaledProfileEditing={disbaledProfileEditing}/>
                <Documentation loadingCustomerProfileDataApi={loadingCustomerProfileDataApi} CustomerProfileDataError={CustomerProfileDataError} CustomerProfileData={CustomerProfileData} disbaledProfileEditing={disbaledProfileEditing}/>
                <Declaration loadingCustomerProfileDataApi={loadingCustomerProfileDataApi} CustomerProfileDataError={CustomerProfileDataError} CustomerProfileData={CustomerProfileData} disbaledProfileEditing={disbaledProfileEditing}/>
            </div>
        </div>

    )
}

export default CustomerProfile